/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeleteHistoryResponse } from '../model';
// @ts-ignore
import { GetHistoriesDocumentsResponse } from '../model';
// @ts-ignore
import { GetHistoriesSearchesResponse } from '../model';
// @ts-ignore
import { PostHistoriesDocumentsParamsBody } from '../model';
/**
 * HistoriesApi - axios parameter creator
 * @export
 */
export const HistoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザーの全ての閲覧履歴を論理削除する。 既に削除済みの履歴は除外され、削除された件数がレスポンスとして返される。
         * @summary 全ての閲覧履歴を削除する（論理削除）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllDocBrowseHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/histories/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーの全ての検索履歴を論理削除する。 検索以外のapi-history履歴は影響を受けない。
         * @summary 全ての検索履歴を削除する（論理削除）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllSearchHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/histories/searches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定されたeventIdの閲覧履歴を論理削除する。 冪等性があり、既に削除済みでも200を返す。
         * @summary 閲覧履歴を削除する（論理削除）
         * @param {string} eventId 削除する閲覧履歴のイベントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocBrowseHistoryEntry: async (eventId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteDocBrowseHistoryEntry', 'eventId', eventId)
            const localVarPath = `/histories/documents/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定されたIDの検索履歴を論理削除する。 idはGET /histories/searchesで返されるES _id。 冪等性があり、既に削除済みでも200を返す。
         * @summary 検索履歴を削除する（論理削除）
         * @param {string} id 検索履歴のドキュメントID（ES _id）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSearchHistoryEntry: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSearchHistoryEntry', 'id', id)
            const localVarPath = `/histories/searches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーが閲覧した資料の一覧を配列で取得する。 何件目から何件目までを表示させるのかはパラメータに応じる。
         * @summary 資料の閲覧履歴を取得する
         * @param {number} from 検索結果の何件目から表示させるのか
         * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrowseHistoryDocuments: async (from: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getBrowseHistoryDocuments', 'from', from)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getBrowseHistoryDocuments', 'size', size)
            const localVarPath = `/histories/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーが行った検索履歴の一覧を取得する。履歴の取得開始位置と件数はパラメータで指定する。
         * @summary 検索履歴一覧を取得する
         * @param {number} from 検索結果の何件目から表示させるのか
         * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistorySearchConditions: async (from: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getHistorySearchConditions', 'from', from)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getHistorySearchConditions', 'size', size)
            const localVarPath = `/histories/searches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーがどの資料を閲覧したのかという履歴を作成する
         * @summary 資料の閲覧履歴を作成する
         * @param {PostHistoriesDocumentsParamsBody} [postHistoriesDocumentsParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHistoriesDocuments: async (postHistoriesDocumentsParamsBody?: PostHistoriesDocumentsParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/histories/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postHistoriesDocumentsParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoriesApi - functional programming interface
 * @export
 */
export const HistoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HistoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザーの全ての閲覧履歴を論理削除する。 既に削除済みの履歴は除外され、削除された件数がレスポンスとして返される。
         * @summary 全ての閲覧履歴を削除する（論理削除）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllDocBrowseHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllDocBrowseHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーの全ての検索履歴を論理削除する。 検索以外のapi-history履歴は影響を受けない。
         * @summary 全ての検索履歴を削除する（論理削除）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllSearchHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllSearchHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定されたeventIdの閲覧履歴を論理削除する。 冪等性があり、既に削除済みでも200を返す。
         * @summary 閲覧履歴を削除する（論理削除）
         * @param {string} eventId 削除する閲覧履歴のイベントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocBrowseHistoryEntry(eventId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocBrowseHistoryEntry(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定されたIDの検索履歴を論理削除する。 idはGET /histories/searchesで返されるES _id。 冪等性があり、既に削除済みでも200を返す。
         * @summary 検索履歴を削除する（論理削除）
         * @param {string} id 検索履歴のドキュメントID（ES _id）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSearchHistoryEntry(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSearchHistoryEntry(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーが閲覧した資料の一覧を配列で取得する。 何件目から何件目までを表示させるのかはパラメータに応じる。
         * @summary 資料の閲覧履歴を取得する
         * @param {number} from 検索結果の何件目から表示させるのか
         * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrowseHistoryDocuments(from: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHistoriesDocumentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrowseHistoryDocuments(from, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーが行った検索履歴の一覧を取得する。履歴の取得開始位置と件数はパラメータで指定する。
         * @summary 検索履歴一覧を取得する
         * @param {number} from 検索結果の何件目から表示させるのか
         * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistorySearchConditions(from: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHistoriesSearchesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistorySearchConditions(from, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーがどの資料を閲覧したのかという履歴を作成する
         * @summary 資料の閲覧履歴を作成する
         * @param {PostHistoriesDocumentsParamsBody} [postHistoriesDocumentsParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postHistoriesDocuments(postHistoriesDocumentsParamsBody?: PostHistoriesDocumentsParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postHistoriesDocuments(postHistoriesDocumentsParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HistoriesApi - factory interface
 * @export
 */
export const HistoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HistoriesApiFp(configuration)
    return {
        /**
         * ユーザーの全ての閲覧履歴を論理削除する。 既に削除済みの履歴は除外され、削除された件数がレスポンスとして返される。
         * @summary 全ての閲覧履歴を削除する（論理削除）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllDocBrowseHistory(options?: any): AxiosPromise<DeleteHistoryResponse> {
            return localVarFp.deleteAllDocBrowseHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーの全ての検索履歴を論理削除する。 検索以外のapi-history履歴は影響を受けない。
         * @summary 全ての検索履歴を削除する（論理削除）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllSearchHistory(options?: any): AxiosPromise<DeleteHistoryResponse> {
            return localVarFp.deleteAllSearchHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * 指定されたeventIdの閲覧履歴を論理削除する。 冪等性があり、既に削除済みでも200を返す。
         * @summary 閲覧履歴を削除する（論理削除）
         * @param {string} eventId 削除する閲覧履歴のイベントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocBrowseHistoryEntry(eventId: string, options?: any): AxiosPromise<DeleteHistoryResponse> {
            return localVarFp.deleteDocBrowseHistoryEntry(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定されたIDの検索履歴を論理削除する。 idはGET /histories/searchesで返されるES _id。 冪等性があり、既に削除済みでも200を返す。
         * @summary 検索履歴を削除する（論理削除）
         * @param {string} id 検索履歴のドキュメントID（ES _id）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSearchHistoryEntry(id: string, options?: any): AxiosPromise<DeleteHistoryResponse> {
            return localVarFp.deleteSearchHistoryEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーが閲覧した資料の一覧を配列で取得する。 何件目から何件目までを表示させるのかはパラメータに応じる。
         * @summary 資料の閲覧履歴を取得する
         * @param {number} from 検索結果の何件目から表示させるのか
         * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrowseHistoryDocuments(from: number, size: number, options?: any): AxiosPromise<GetHistoriesDocumentsResponse> {
            return localVarFp.getBrowseHistoryDocuments(from, size, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーが行った検索履歴の一覧を取得する。履歴の取得開始位置と件数はパラメータで指定する。
         * @summary 検索履歴一覧を取得する
         * @param {number} from 検索結果の何件目から表示させるのか
         * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistorySearchConditions(from: number, size: number, options?: any): AxiosPromise<GetHistoriesSearchesResponse> {
            return localVarFp.getHistorySearchConditions(from, size, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーがどの資料を閲覧したのかという履歴を作成する
         * @summary 資料の閲覧履歴を作成する
         * @param {PostHistoriesDocumentsParamsBody} [postHistoriesDocumentsParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHistoriesDocuments(postHistoriesDocumentsParamsBody?: PostHistoriesDocumentsParamsBody, options?: any): AxiosPromise<void> {
            return localVarFp.postHistoriesDocuments(postHistoriesDocumentsParamsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoriesApi - interface
 * @export
 * @interface HistoriesApi
 */
export interface HistoriesApiInterface {
    /**
     * ユーザーの全ての閲覧履歴を論理削除する。 既に削除済みの履歴は除外され、削除された件数がレスポンスとして返される。
     * @summary 全ての閲覧履歴を削除する（論理削除）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApiInterface
     */
    deleteAllDocBrowseHistory(options?: AxiosRequestConfig): AxiosPromise<DeleteHistoryResponse>;

    /**
     * ユーザーの全ての検索履歴を論理削除する。 検索以外のapi-history履歴は影響を受けない。
     * @summary 全ての検索履歴を削除する（論理削除）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApiInterface
     */
    deleteAllSearchHistory(options?: AxiosRequestConfig): AxiosPromise<DeleteHistoryResponse>;

    /**
     * 指定されたeventIdの閲覧履歴を論理削除する。 冪等性があり、既に削除済みでも200を返す。
     * @summary 閲覧履歴を削除する（論理削除）
     * @param {string} eventId 削除する閲覧履歴のイベントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApiInterface
     */
    deleteDocBrowseHistoryEntry(eventId: string, options?: AxiosRequestConfig): AxiosPromise<DeleteHistoryResponse>;

    /**
     * 指定されたIDの検索履歴を論理削除する。 idはGET /histories/searchesで返されるES _id。 冪等性があり、既に削除済みでも200を返す。
     * @summary 検索履歴を削除する（論理削除）
     * @param {string} id 検索履歴のドキュメントID（ES _id）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApiInterface
     */
    deleteSearchHistoryEntry(id: string, options?: AxiosRequestConfig): AxiosPromise<DeleteHistoryResponse>;

    /**
     * ユーザーが閲覧した資料の一覧を配列で取得する。 何件目から何件目までを表示させるのかはパラメータに応じる。
     * @summary 資料の閲覧履歴を取得する
     * @param {number} from 検索結果の何件目から表示させるのか
     * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApiInterface
     */
    getBrowseHistoryDocuments(from: number, size: number, options?: AxiosRequestConfig): AxiosPromise<GetHistoriesDocumentsResponse>;

    /**
     * ユーザーが行った検索履歴の一覧を取得する。履歴の取得開始位置と件数はパラメータで指定する。
     * @summary 検索履歴一覧を取得する
     * @param {number} from 検索結果の何件目から表示させるのか
     * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApiInterface
     */
    getHistorySearchConditions(from: number, size: number, options?: AxiosRequestConfig): AxiosPromise<GetHistoriesSearchesResponse>;

    /**
     * ユーザーがどの資料を閲覧したのかという履歴を作成する
     * @summary 資料の閲覧履歴を作成する
     * @param {PostHistoriesDocumentsParamsBody} [postHistoriesDocumentsParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApiInterface
     */
    postHistoriesDocuments(postHistoriesDocumentsParamsBody?: PostHistoriesDocumentsParamsBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * HistoriesApi - object-oriented interface
 * @export
 * @class HistoriesApi
 * @extends {BaseAPI}
 */
export class HistoriesApi extends BaseAPI implements HistoriesApiInterface {
    /**
     * ユーザーの全ての閲覧履歴を論理削除する。 既に削除済みの履歴は除外され、削除された件数がレスポンスとして返される。
     * @summary 全ての閲覧履歴を削除する（論理削除）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApi
     */
    public deleteAllDocBrowseHistory(options?: AxiosRequestConfig) {
        return HistoriesApiFp(this.configuration).deleteAllDocBrowseHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーの全ての検索履歴を論理削除する。 検索以外のapi-history履歴は影響を受けない。
     * @summary 全ての検索履歴を削除する（論理削除）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApi
     */
    public deleteAllSearchHistory(options?: AxiosRequestConfig) {
        return HistoriesApiFp(this.configuration).deleteAllSearchHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定されたeventIdの閲覧履歴を論理削除する。 冪等性があり、既に削除済みでも200を返す。
     * @summary 閲覧履歴を削除する（論理削除）
     * @param {string} eventId 削除する閲覧履歴のイベントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApi
     */
    public deleteDocBrowseHistoryEntry(eventId: string, options?: AxiosRequestConfig) {
        return HistoriesApiFp(this.configuration).deleteDocBrowseHistoryEntry(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定されたIDの検索履歴を論理削除する。 idはGET /histories/searchesで返されるES _id。 冪等性があり、既に削除済みでも200を返す。
     * @summary 検索履歴を削除する（論理削除）
     * @param {string} id 検索履歴のドキュメントID（ES _id）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApi
     */
    public deleteSearchHistoryEntry(id: string, options?: AxiosRequestConfig) {
        return HistoriesApiFp(this.configuration).deleteSearchHistoryEntry(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーが閲覧した資料の一覧を配列で取得する。 何件目から何件目までを表示させるのかはパラメータに応じる。
     * @summary 資料の閲覧履歴を取得する
     * @param {number} from 検索結果の何件目から表示させるのか
     * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApi
     */
    public getBrowseHistoryDocuments(from: number, size: number, options?: AxiosRequestConfig) {
        return HistoriesApiFp(this.configuration).getBrowseHistoryDocuments(from, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーが行った検索履歴の一覧を取得する。履歴の取得開始位置と件数はパラメータで指定する。
     * @summary 検索履歴一覧を取得する
     * @param {number} from 検索結果の何件目から表示させるのか
     * @param {number} size 検索結果の表示開始位置から何件目まで表示させるのか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApi
     */
    public getHistorySearchConditions(from: number, size: number, options?: AxiosRequestConfig) {
        return HistoriesApiFp(this.configuration).getHistorySearchConditions(from, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーがどの資料を閲覧したのかという履歴を作成する
     * @summary 資料の閲覧履歴を作成する
     * @param {PostHistoriesDocumentsParamsBody} [postHistoriesDocumentsParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoriesApi
     */
    public postHistoriesDocuments(postHistoriesDocumentsParamsBody?: PostHistoriesDocumentsParamsBody, options?: AxiosRequestConfig) {
        return HistoriesApiFp(this.configuration).postHistoriesDocuments(postHistoriesDocumentsParamsBody, options).then((request) => request(this.axios, this.basePath));
    }
}
